
import { v4 as uuidv4 } from 'uuid'

export const initialAddTitles = async (newId, data = null) => {

    const lastCorr = 0;
    return {
        correlativo: lastCorr,
        id: newId,
        index: newId,
        creado: false,
        nombre: data?.nombre || '',
        cant: data?.cant || 1,
        dias: data?.dias || 1,
        costo_unitario: data?.costo_unitario || 0,
        costo_subtotal: data?.costo_subtotal || 0,

        total_gasto_actual: 0,
        porcentaje_gasto_actual: 0,
        total_saldo: 0,
        porcentaje_saldo: 0,

        tipo: 'title',
        codigo: '',
        id_servicio: data?.id_servicio || 0,
        id_categoria: data?.id_categoria || 0,
        abierto: data?.abierto || false,
        id_titulo: 0,
        sorting: null,
        selected: false,
        items: [],
    }
}

export const initialAddItems = async (params) => {

    const {
        newId,
        idTitle,
        sorting,
        data,
        categoryId
    } = params

    // console.log('-categoryId LLL-', categoryId)

    const lastCorr = 0;
    return {
        correlativo: lastCorr,
        id: newId,
        index: newId,
        creado: false,
        nombre: data?.nombre || '',
        cant: data?.cant || 1,
        dias: data?.dias || 1,
        costo_unitario: data?.costo_unitario || 0,
        costo_subtotal: data?.costo_subtotal || 0,

        total_gasto_actual: 0,
        porcentaje_gasto_actual: 0,
        total_saldo: 0,
        porcentaje_saldo: 0,

        tipo: 'item',
        codigo: data?.codigo || '',
        id_servicio: data?.id_servicio || 0,
        id_categoria: data?.id_categoria || (categoryId ? categoryId : 0),
        abierto: data?.abierto || false,
        id_titulo: idTitle,
        sorting,
        selected: false,
        items: [],
        id_tipo_doc: 1 // 18% factura
    }
}

export const initialDuplicateItems = (item, newId) => {
    return {
        correlativo: 0,
        id: newId,
        index: newId,
        nombre: item.nombre,
        cant: item.cant,
        dias: item.dias,
        costo_unitario: item.costo_unitario,
        costo_subtotal: item.costo_subtotal,

        total_gasto_actual: 0,
        porcentaje_gasto_actual: 0,
        total_saldo: 0,
        porcentaje_saldo: 0,

        tipo: item.tipo,
        codigo: item.codigo,
        id_servicio: item.id_servicio,
        id_categoria: item.id_categoria,
        abierto: item.abierto,
        id_titulo: item.id_titulo,
        sorting: item.sorting,
        selected: false,
        items: item.items,

        id_tipo_doc: item?.id_tipo_doc || 1 // 18% factura
    }
}

export const initialCalculoTotales = async (detail, Newitems) => {

    let totalCostos = 0;
    for (let i = 0; i < Newitems.length; i++) {
        const el = Newitems[i];
        if (Newitems[i].tipo === 'title') {
            const itemsByTitle = el.items;
            for (let x = 0; x < itemsByTitle.length; x++) {
                const element = itemsByTitle[x];
                totalCostos += element.costo_subtotal
            }
        }
    }

    const newTotales = {
        total_ppto: totalCostos
    }

    return newTotales

}

// items pptos gastos
export const initialAddTitlesPptosGastos = async (newId) => {
    return {
        id: newId,
        index: newId,
        creado: false,
        nombre: '',
        cant: 0,
        dias: 0,
        valor_unitario: 0,
        subtotal: 0,
        total_gasto_actual: 0,
        porcentaje_gasto_actual: 0,
        total_saldo: 0,
        porcentaje_saldo: 0,
        tipo: 'title',
        cerrado_compras: '',
        id_servicio: 0,
        id_categoria: 0,
        id_titulo: '',
        selected: false,
        items: [],
    }
}

export const initialAddItemsPptosGastos = async (newId, idTitulo) => {
    return {
        id: newId,
        index: newId,
        creado: false,
        nombre: '',
        cant: 1,
        dias: 1,
        valor_unitario: 0,
        subtotal: 0,
        total_gasto_actual: 0,
        porcentaje_gasto_actual: 0,
        total_saldo: 0,
        porcentaje_saldo: 0,
        tipo: 'item',
        cerrado_compras: '',
        id_servicio: 0,
        id_categoria: 0,
        id_titulo: idTitulo,
        selected: false,
    }
}

export const initialCalculoTotalesPptosGastos = async (detail, Newitems) => {

    let sumaSubtotal = 0;
    for (let i = 0; i < Newitems.length; i++) {
        const el = Newitems[i];
        if (Newitems[i].tipo === 'title') {
            const itemsByTitle = el.items;
            for (let x = 0; x < itemsByTitle.length; x++) {
                const element = itemsByTitle[x];
                sumaSubtotal += element.subtotal;
            }
        }
    }

    const newTotales = {
        total: sumaSubtotal,
    }

    return newTotales;
}

// initial items

const getCatSelected = (items, catalogGroup) => {
    let catSelected = []

    for (let x = 0; x < items.length; x++) {
        const foundTitleId = catSelected.find(it => it.id === items[x].id_categoria)
        if (!foundTitleId) {
            const title = catalogGroup.find(t => t.id === items[x].id_categoria)
            catSelected = [
                ...catSelected,
                {
                    id: title.id,
                    name: title.nombre
                }
            ]
        }
    }

    return catSelected

}

export const sortInitialItem = async (selectedItems, catalogGroup) => {
    const catSelected = getCatSelected(selectedItems, catalogGroup)

    let orderedItems = []
    for (let i = 0; i < catSelected.length; i++) {
        const currentCat = catSelected[i]

        const newIdTitle = uuidv4()
        let newTitle = await initialAddTitles(newIdTitle)

        newTitle = {
            ...newTitle,
            id_categoria: currentCat.id,
            nombre: currentCat.name
        }

        // sorting items by title
        let sortingByTitle = null
        for (let x = 0; x < selectedItems.length; x++) {
            const it = selectedItems[x]
            console.log('--it--', it)

            if (it.id_categoria === currentCat.id) {
                sortingByTitle = sortingByTitle ? (sortingByTitle + 1) : 0

                const newId = uuidv4()
                let item = await initialAddItems(newId, newIdTitle, sortingByTitle)

                item = {
                    ...item,
                    nombre: it.nombre,
                    id_servicio: it.id,
                    id_categoria: it.id_categoria
                }

                newTitle = {
                    ...newTitle,
                    items: [...newTitle.items, item]
                }

            }

        }

        // add item by title
        orderedItems = [...orderedItems, newTitle]

    }

    console.log('--orderedItems--', orderedItems)

    return orderedItems

}